import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MonitorIcon, UsersIcon, ActivityIcon } from 'lucide-react';
export function Hero() {
  const [currentServing, setCurrentServing] = useState('A-104');
  // Simulate queue progression for the mockup
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentServing(prev => {
        const num = parseInt(prev.split('-')[1]);
        return `A-${num + 1}`;
      });
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <section className="pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden" data-id="element-86">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-88">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-89">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-100 border border-slate-200 mb-6" data-id="element-90">
              <span className="flex h-2 w-2 rounded-full bg-accent" data-id="element-91"></span>
              <span className="text-xs font-semibold text-slate-700 uppercase tracking-wider" data-id="element-92">
                Secure Local Deployment
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-heading leading-[1.1] mb-6" data-id="element-93">
              Transforming Waiting into{' '}
              <span className="text-accent" data-id="element-94">Seamless Service.</span>
            </h1>

            <p className="text-lg sm:text-xl text-slate-600 mb-8 leading-relaxed" data-id="element-95">
              An intelligent Token and Progress Management System designed for
              banks, hospitals, and government offices. Streamline customer flow
              with smart calling and real-time tracking.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-96">
              <button className="bg-primary hover:bg-primary-light text-white px-6 py-3.5 rounded-md font-medium text-base transition-colors flex items-center justify-center gap-2 shadow-lg shadow-slate-900/10" data-id="element-97">
                Request a Demo
                <ArrowRightIcon className="w-4 h-4" data-id="element-98" />
              </button>
              <button className="bg-white hover:bg-slate-50 text-slate-700 border border-slate-200 px-6 py-3.5 rounded-md font-medium text-base transition-colors flex items-center justify-center gap-2" data-id="element-99">
                See how it works
              </button>
            </div>

            <div className="mt-10 flex items-center gap-6 text-sm text-slate-500 font-medium" data-id="element-100">
              <div className="flex items-center gap-2" data-id="element-101">
                <MonitorIcon className="w-4 h-4 text-slate-400" data-id="element-102" />
                <span data-id="element-103">Real-time Displays</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-104">
                <UsersIcon className="w-4 h-4 text-slate-400" data-id="element-105" />
                <span data-id="element-106">Department-wise Routing</span>
              </div>
            </div>
          </motion.div>

          {/* Token Display Unit Mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative mx-auto w-full max-w-lg lg:max-w-none" data-id="element-107">
            {/* Decorative background elements */}
            <div className="absolute -inset-4 bg-slate-200/50 rounded-2xl blur-xl -z-10" data-id="element-108"></div>

            <div className="bg-[#0a0f1c] rounded-xl shadow-2xl overflow-hidden border-4 border-slate-800 flex flex-col" data-id="element-109">
              {/* Mockup Header */}
              <div className="bg-slate-800 px-6 py-3 flex justify-between items-center border-b border-slate-700" data-id="element-110">
                <div className="flex items-center gap-2" data-id="element-111">
                  <ActivityIcon className="w-5 h-5 text-slate-400" data-id="element-112" />
                  <span className="text-slate-300 font-semibold tracking-wide text-sm" data-id="element-113">
                    ERPLogiFlow Display
                  </span>
                </div>
                <div className="flex gap-1.5" data-id="element-114">
                  <div className="w-2 h-2 rounded-full bg-red-500" data-id="element-115"></div>
                  <div className="w-2 h-2 rounded-full bg-amber-500" data-id="element-116"></div>
                  <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-117"></div>
                </div>
              </div>

              {/* Main Display Area */}
              <div className="p-8 flex flex-col gap-6" data-id="element-118">
                {/* Now Serving */}
                <div className="bg-[#131b2f] rounded-lg p-6 border border-slate-700/50 relative overflow-hidden" data-id="element-119">
                  <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-accent to-transparent opacity-50" data-id="element-120"></div>
                  <h3 className="text-slate-400 text-sm font-medium uppercase tracking-widest mb-2" data-id="element-121">
                    Now Serving
                  </h3>
                  <div className="flex justify-between items-end" data-id="element-122">
                    <div data-id="element-123">
                      <div className="text-slate-500 text-sm mb-1" data-id="element-124">
                        Token Number
                      </div>
                      <motion.div key={currentServing} initial={{
                      opacity: 0,
                      y: -10
                    }} animate={{
                      opacity: 1,
                      y: 0
                    }} className="text-5xl sm:text-7xl font-bold text-amber-500 font-led drop-shadow-[0_0_15px_rgba(245,158,11,0.4)]" data-id="element-125">
                        {currentServing}
                      </motion.div>
                    </div>
                    <div className="text-right" data-id="element-126">
                      <div className="text-slate-500 text-sm mb-1" data-id="element-127">Counter</div>
                      <div className="text-4xl sm:text-5xl font-bold text-white font-led" data-id="element-128">
                        03
                      </div>
                    </div>
                  </div>
                </div>

                {/* Queue Status Rows */}
                <div className="grid grid-cols-2 gap-4" data-id="element-129">
                  <div className="bg-[#131b2f] rounded-lg p-4 border border-slate-700/50" data-id="element-130">
                    <div className="text-slate-400 text-xs uppercase tracking-wider mb-2" data-id="element-131">
                      Loan Dept
                    </div>
                    <div className="flex justify-between items-center" data-id="element-132">
                      <span className="text-slate-300 text-sm" data-id="element-133">Serving:</span>
                      <span className="text-amber-500 font-bold font-led text-xl" data-id="element-134">
                        L-042
                      </span>
                    </div>
                    <div className="flex justify-between items-center mt-1" data-id="element-135">
                      <span className="text-slate-500 text-xs" data-id="element-136">Waiting:</span>
                      <span className="text-slate-300 font-medium" data-id="element-137">12</span>
                    </div>
                  </div>
                  <div className="bg-[#131b2f] rounded-lg p-4 border border-slate-700/50" data-id="element-138">
                    <div className="text-slate-400 text-xs uppercase tracking-wider mb-2" data-id="element-139">
                      Cash Dept
                    </div>
                    <div className="flex justify-between items-center" data-id="element-140">
                      <span className="text-slate-300 text-sm" data-id="element-141">Serving:</span>
                      <span className="text-amber-500 font-bold font-led text-xl" data-id="element-142">
                        C-218
                      </span>
                    </div>
                    <div className="flex justify-between items-center mt-1" data-id="element-143">
                      <span className="text-slate-500 text-xs" data-id="element-144">Waiting:</span>
                      <span className="text-slate-300 font-medium" data-id="element-145">5</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Ticker */}
              <div className="bg-slate-900 py-2 px-4 border-t border-slate-800 overflow-hidden" data-id="element-146">
                <motion.div animate={{
                x: [0, -1000]
              }} transition={{
                repeat: Infinity,
                duration: 20,
                ease: 'linear'
              }} className="whitespace-nowrap text-slate-400 text-sm font-medium" data-id="element-147">
                  Welcome to our branch. Please collect your token from the
                  kiosk. • कृपया आफ्नो टोकन मेसिनबाट लिनुहोला। • Welcome to our
                  branch...
                </motion.div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}